module.exports = __webpack_public_path__ + "327bb022a3a144666aa801248917e3c9.png";